// Service Area Type Enum
export enum ServiceAreaType {
    METROPOLITAN = 1,
    CITY = 2,
    REGION = 3,
    PROVINCE = 4
}

// Service Area Status Enum
export enum ServiceAreaStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    PENDING = "PENDING"
}

// Service Area Type Interface
export interface ServiceAreaTypeInfo {
    id: number;
    name: string;
    description?: string;
}

// Service Area Country Interface
export interface ServiceAreaCountry {
    id: string;
    name: string;
    code: string;
}

// Service Area Interface
export interface ServiceArea {
    id: string;
    name: string;
    type: ServiceAreaTypeInfo;
    radius: number;
    restrictions: string[];
    cities: string[];
    postalCodes: string[];
    country: ServiceAreaCountry;
    serviceTypes: string[];
    emergencyServices: boolean;
    province: string;
    status?: ServiceAreaStatus;
    createdAt?: string;
    updatedAt?: string;
}

// Service Area Create/Update Request Interface
export interface ServiceAreaRequest {
    name: string;
    type: { id: number };
    radius: number;
    restrictions: string[];
    cities: string[];
    postalCodes: string[];
    country: { id: string };
    serviceTypes: string[];
    emergencyServices: boolean;
    province: string;
}

// Service Area Response Interface
export interface ServiceAreaResponse {
    data: ServiceArea[];
    totalCount: number;
    hasNextPage: boolean;
}

// Service Area Filter Interface
export interface ServiceAreaFilter {
    search?: string;
    type?: number;
    country?: string;
    status?: ServiceAreaStatus;
    emergencyServices?: boolean;
}

// Service Area Pagination Interface
export interface ServiceAreaPagination {
    page: number;
    limit: number;
}

// Service Area Form Data Interface
export interface ServiceAreaFormData {
    name: string;
    type: { id: number };
    radius: string; // string for form input, will be converted to number
    restrictions: string[];
    cities: string[];
    postalCodes: string[];
    country: { id: string };
    serviceTypes: string[];
    emergencyServices: boolean;
    province: string;
}

// Service Area Type Display Names
export const SERVICE_AREA_TYPE_DISPLAY_NAMES = {
    [ServiceAreaType.METROPOLITAN]: "Metropolitan Area",
    [ServiceAreaType.CITY]: "City",
    [ServiceAreaType.REGION]: "Region",
    [ServiceAreaType.PROVINCE]: "Province"
} as const;

// Service Area Status Display Names
export const SERVICE_AREA_STATUS_DISPLAY_NAMES = {
    [ServiceAreaStatus.ACTIVE]: "Active",
    [ServiceAreaStatus.INACTIVE]: "Inactive",
    [ServiceAreaStatus.PENDING]: "Pending"
} as const;